import { z } from "zod";

export namespace BizLocationModels {
  /**
   * BizLocationPaginationFilterDtoSchema
   * @type { object }
   * @property { string } name
   */
  export const BizLocationPaginationFilterDtoSchema = z.object({ name: z.string() }).partial();
  export type BizLocationPaginationFilterDto = z.infer<typeof BizLocationPaginationFilterDtoSchema>;

  /**
   * BizLocationPaginationResponseDtoSchema
   * @type { object }
   * @property { string[] } items Items
   * @property { object[] } order List of order definitions
   * @property { number } page 1-indexed page number to begin from
   * @property { string } cursor ID of item to start after
   * @property { string } nextCursor Cursor for next set of items
   * @property { number } limit Items per response
   * @property { number } totalItems Total available items
   */
  export const BizLocationPaginationResponseDtoSchema = z.object({
    items: z.array(z.string()),
    order: z.array(z.object({})).optional(),
    page: z.number().optional(),
    cursor: z.string().optional(),
    nextCursor: z.string().optional(),
    limit: z.number(),
    totalItems: z.number(),
  });
  export type BizLocationPaginationResponseDto = z.infer<typeof BizLocationPaginationResponseDtoSchema>;
}
